export default "__VITE_ASSET__Yr4yOIsn__"